import { render } from "./widget_management.html?vue&type=template&id=7c3944f7&scoped=true&external"
import script from "./widget_management.js?vue&type=script&lang=js&external"
export * from "./widget_management.js?vue&type=script&lang=js&external"

import "./WidgetManagement.vue?vue&type=style&index=0&id=7c3944f7&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3944f7"]])

export default __exports__